export default {
  monthCount: {
    en: '{count, plural, one {# month} other {# months}} break',
  },
  restartDate: {
    en: 'Restarts {date}',
  },
}
